import React from 'react';
import './ITSoftware.css';

function TourismHospitality() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/tourism_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Hospitality & Tourism </h1>
          <p>Strategic tax, FDI, and operational compliance for hospitality and travel businesses</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Fueling Tourism Excellence with Financial Precision</h2>
          <p>We assist hotels, resorts, travel platforms, and hospitality startups with GST, TCS, and cross-border compliance.</p>
          <p>From franchise accounting to food licensing (FSSAI), we manage your financial and legal backend seamlessly.</p>
          <p>Whether it's TDS on commissions or invoice structuring for packages, our experts ensure clarity and compliance.</p>
          <p>We also support international inbound operators with FEMA advisory and tourist refund schemes where applicable.</p>
        </div>
        <div className="content-right">
          <img src="/images/tourism.jpg" alt="Tourism & Hospitality" />
        </div>
      </section>
    </div>
  );
}

export default TourismHospitality;
